var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-text",class:{ 'have-badge': _vm.checkBadge },style:(_vm.styleProperty)},[_vm._v(" "+_vm._s(_vm.columnProperties.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }